import mixpanel from 'mixpanel-browser'
import { ViewEvent } from '~/passporter-services/shared/metrics'
import { BaseMetric } from './baseMetric'
import { Destination2 } from '~/models/Destination'

export class TripMenuMetric extends BaseMetric {
	public static viewTripMenu(destination: string, id: string, routeName?: string): void {
		new ViewEvent('menu', routeName).destination(destination).id(id).send(this.gtag, mixpanel)
	}

	public static viewTripDialog(destination?: Destination2): void {
		const plannerRouteName: string = 'trip-itinerary_id-itinerary'
		let element: string = 'wizard'
		const destinationId = destination?.id
		if (destinationId) element = 'settings'
		const event = new ViewEvent(element, plannerRouteName)
		if (destinationId) {
			const standardizedName = destination.standardizedName || destination.name
			event.destination(standardizedName).id(destinationId)
		}
		event.send(this.gtag, mixpanel)
	}
}
